/*
 * @Author: zwt.daffy
 * @Date: 2019-08-05 10:03:13
 * @Last Modified by: zwt.daffy
 * @Last Modified time: 2020-02-21 14:05:43
 * 用户管理接口
 */
import request from '@/api/base'

// 获取用户信息
const getUserInfo = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.get('/portal/user/getCurrentLoginUmUserInfo', {params})
}

const queryAllManager = (params) => {
  return request.post('/portal/park/user/findParkUsers', params)
}

// 获取菜单树2
const getUserMenus = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/menu/user/getUserMenus', params)
}
// 查询运营人员
const queryAllUserByParkId = (params) => {
  return request.post('/portal/park/user/findParkUsers', params)
}
// 查询用户信息
const findCompanyStaffs = (params) => {
  return request.post('/portal/user/findCompanyStaffs', params)
}
// 查询园区人员列表
const queryAllUsers = (params) => {
  return request.post('/portal/user/queryStaffList', params)
}
// 查询园区企业列表
const queryCompany = (params) => {
  return request.post('/portal/company/queryList', params)
}

// 登录
const userLogin = (params) => {
  return request.post('/company/user/login', params)
  // return request.post('/pvlg/login', params)
}

const getVaildCode = () => {
  return request.post('/pvlg/getVaildCode?randomrs=' + Date.now())
}

const userForgetPassword = (params) => {
  const {
    loginName,
    newPassword
  } = params
  return request.post('/forgetPassword', {
    loginName: loginName,
    newPassword: newPassword
  })
}

const userChangePassword = (userPassword) => {
  const {
    oldPassword,
    newPassword
  } = userPassword
  return request.post('/modifyPassword', {
    oldPassword: oldPassword,
    newPassword: newPassword
  })
}

// 仪表规格列表
const getdeviceModelList = (params) => {
  return request.get('/portal/device/getDeviceModelByPage', {params})
}

// 公司下新增一个空白仪表
const bindingMeterToCompany = (params) => {
  return request.post('/portal/device/bill/bindingMeterToCompany', params)
}
// 公司下新增一个虚拟仪表
const saveVirtualMeter = (params) => {
  return request.post('/portal/device/bill/saveVirtualMeter', params)
}
// 获取设备类型
const getDeviceTypeList = (params) => {
  return request.get('/portal/device/getDeviceType', {params})
}
// 删除仪表规格
const delDeviceModel = (params) => {
  return request.post('/portal/device/delDeviceModel', params)
}
// 添加仪表规格
const addDeviceModel = (params) => {
  return request.post('/portal/device/addDeviceModel', params)
}

// 编辑仪表
const editDevice = (params) => {
  return request.post('/portal/device/editMeter', params)
}
// 编辑仪表规格
const editDeviceModel = (params) => {
  return request.post('/portal/device/editDeviceModel', params)
}
// 获取区域列表
const getRegionInfo = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.get('/portal/estate/regionInfo', {params})
}
// 获取楼栋列表
const getBuildInfo = (params) => {
  return request.post('/portal/estate/buildInfo', params)
}
// 获取楼栋层列表
const getFloorInfo = (params) => {
  return request.post('/portal/estate/floorInfo', params)
}
// 获取房间列表
const getRoomInfo = (params) => {
  return request.post('/portal/room/queryList/map', params)
}
// 获取抄表人列表
const getMeterReaderList = (params) => {
  return request.get('/portal/device/getMeterReaderList', {params})
}
// 按条件分页查询抄表记录
const getqueryList = (params) => {
  // params.test = true
  return request.post('/portal/device/getMeterValueRecordPageByCondition', params)
}
// 按条件分页查询能源账单
const getMeterValueRecordPageByParam = (params) => {
  // params.test = true
  return request.post('/portal/device/getMeterValueRecordPageByParam', params)
}
// 按条件分页查询生成能源账单
const getEnergyBillByParam = (params) => {
  // params.test = true
  return request.post('/portal/device/getEnergyBillByParam', params)
}
// 导出抄表记录
const exportMeterRecordList = (params) => {
  return request.post('/portal/device/exportMeterValueRecordByCondition', params, { responseType: 'blob' })
}

// 获取仪表树
const getMeterTreeByParkId = (params) => {
  return request.get('/portal/device/getMeterTreeByParkId', {params})
}
// 包含绑定公司的所有仪表
const getMeterByPage = (params) => {
  return request.post('/portal/device/getMeterByPage', params)
}
// 包含绑定公司的所有虚拟仪表
const getVirtualMeter = (params) => {
  return request.post('/portal/device/bill/getVirtualMeter', params)
}
// 尚未绑定公司的仪表
const getNoBindingMeterByPage = (params) => {
  return request.post('/portal/device/getNoBindingMeterByPage', params)
}
// 查询企业列表（关联查询企业对应的仪表信息）
const queryCompanyWithMeter = (params) => {
  return request.post('/portal/companyBook/queryCompanyWithMeter', params)
}

// 查询企业列表（关联查询企业对应的仪表信息）
const queryCompanyAndMeterSet = (params) => {
  return request.post('/portal/companyBook/queryCompanyAndMeterSet', params)
}
// 导入抄表记录
const importMeterCheck = (params) => {
  return request.post('/portal/device/importMeterCheck', params, { responseType: 'blob' })
}
// 导出仪表信息
const exportMeterInfo = (params) => {
  return request.get('/portal/device/exportMeterInfo', {params}, { responseType: 'blob' })
}

// 删除仪表
const delMeter = (params) => {
  return request.post('/portal/device/delMeter', params)
}
// 根据设备类型获取仪表规格
const getDeviceModelByTypeOpen = (params) => {
  return request.get('/portal/device/getDeviceModelByType', {params})
}
// 添加仪表
const addMeter = (params) => {
  return request.post('/portal/device/addMeter', params)
}
// 获取单个仪表详情
const getDeviceInfobyId = (params) => {
  return request.get('/portal/device/bill/getDeviceInfobyId', {params})
}
// 获取当前收费项目下启用状态的收费标准列表
const queryBillTypeByDeviceType = (params) => {
  // params.test = true
  return request.post('/portal/device/bill/queryBillTypeByDeviceType', params)
}
const newQueryBillTypeByDeviceType = (params) => {
  // params.test = true
  return request.get('/portal/device/bill/getBillTypeInfo', {params})
}
// 获取当前收费项目下启用状态的收费标准列表device/bill/updateBillType
const checkBillStandardRelevant = (params) => {
  // params.test = true
  return request.get('/portal/device/bill/checkBillStandardRelevant', {params})
}
// 修改收费款项
const updateBillType = (params) => {
  // params.test = true
  return request.post('/portal/device/bill/updateBillType', params)
}
// 查询设备绑定的企业设置
const queryBillSettingByMeter = (params) => {
  // params.test = true
  return request.post('/portal/device/bill/queryBillSettingByMeter', params)
}
// 修改企业设置
const updateBillSetting = (params) => {
  // params.test = true
  return request.post('/portal/device/bill/updateBillSetting', params)
}
// 生成账单--旧借口
const createBill = (params) => {
  // params.test = true
  return request.post('/portal/device/bill/createBill', params)
}
// 生成账单--新借口
const createEnergyBill = (params) => {
  // params.test = true
  return request.post('/portal/device/createEnergyBill', params)
}
// 检查生成账单是否先关联了公司
const checkCreateBil = (params) => {
  // params.test = true
  return request.post('/portal/device/bill/checkCreateBill', params)
}
// 能源账单列表页
const getBillRecordPageByCondition = (params) => {
  // params.test = true
  return request.post('/portal/device/bill/getBillRecordPageByCondition', params)
}

// 获取所有收费标准
const getBillTypeList = (params) => {
  return request.get('/portal/device/bill/getBillTypeList', {params})
}

// 删除企业绑定中的仪表
const deleteBillSetting = (params) => {
  return request.post('/portal/device/bill/deleteBillSetting', params)
}
// 删除企业绑定的虚拟仪表
const delVirtualMeter = (params) => {
  return request.post('/portal/device/bill/delVirtualMeter', params)
}
// 查询运管企业/食堂/物业公司的部门信息
const geDepartmentAndUserInfo = (params) => {
  return request.post('/portal/department/getParkCompanyDepartmentAndUserInfo', params)
}
// 查询部门人员信息
const getDepartmentUserInfo = (params) => {
  return request.post('/portal/department/getDepartmentUserInfo', params)
}
// 查询企业列表
const queryGroupCompany = (params) => {
  return request.post('/portal/company/queryGroupCompany', params)
}
// 查询企业列表
const queryListIncludeAddress = (params) => {
  return request.post('/portal/company/queryListIncludeAddress', params)
}
// 查询内置角色
const queryInnerBusRole = (params) => {
  return request.get('/portal/role/bus/queryInnerBusRole', { params })
}
export default {
  deleteBillSetting,
  delVirtualMeter,
  queryCompanyWithMeter,
  getNoBindingMeterByPage,
  userLogin,
  checkCreateBil,
  getBillTypeList,
  getBillRecordPageByCondition,
  createBill,
  updateBillType,
  queryBillSettingByMeter,
  getMeterValueRecordPageByParam,
  updateBillSetting,
  checkBillStandardRelevant,
  queryBillTypeByDeviceType,
  bindingMeterToCompany,
  queryCompanyAndMeterSet,
  getVaildCode,
  userForgetPassword,
  userChangePassword,
  getUserMenus,
  getUserInfo,
  queryAllUserByParkId,
  queryAllUsers,
  queryCompany,
  getdeviceModelList,
  getDeviceTypeList,
  saveVirtualMeter,
  delDeviceModel,
  getVirtualMeter,
  addDeviceModel,
  editDeviceModel,
  getRegionInfo,
  getBuildInfo,
  getFloorInfo,
  getMeterReaderList,
  getqueryList,
  exportMeterRecordList,
  getMeterTreeByParkId,
  getMeterByPage,
  exportMeterInfo,
  importMeterCheck,
  delMeter,
  getDeviceModelByTypeOpen,
  addMeter,
  getDeviceInfobyId,
  getRoomInfo,
  createEnergyBill,
  editDevice,
  getEnergyBillByParam,
  queryAllManager,
  newQueryBillTypeByDeviceType,
  geDepartmentAndUserInfo,
  getDepartmentUserInfo,
  findCompanyStaffs,
  queryGroupCompany,
  queryListIncludeAddress,
  queryInnerBusRole
}



// WEBPACK FOOTER //
// ./src/area-base/api/userService.js